<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增子活动配置' : '编辑子活动配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :width="width"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item v-if="!this.isCreated" label="ID：" prop="id">
          <el-input style="width: 200px" v-model="form.id" readonly></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <!-- <el-input v-model="form.type"></el-input> -->
          <el-select
            @change="typeValueChange"
            v-model="form.type"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in types"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述：" prop="desc">
          <el-input
            style="width: 300px"
            placeholder="用于区分同一类型不同的实例，首次可不填"
            v-model="form.desc"
          ></el-input>
          <span style="color: red">（对于相同类型的活动，描述必须唯一）</span>
        </el-form-item>

        <el-form-item label="参数：" prop="parameter">
          <el-card class="box-card">
            <div v-if="hasUI" style="margin-bottom: 10px">
              使用JSON模式：<el-switch
                v-model="isShowJson"
                active-color="#13ce66"
                @change="toJsonSwitch"
              >
              </el-switch>
            </div>
            <div
              v-if="!isShowJson && form.type == typeEumn.heroUpgradeGiftName"
            >
              <HeroUpgradeGift
                :parameter="form.parameter"
                @updated="upsertParameter"
              />
            </div>
            <div
              v-else-if="
                !isShowJson && form.type == typeEumn.heroUpgradeTaskName
              "
            >
              <HeroUpgradeTask
                :parameter="form.parameter"
                @updated="upsertParameter"
              />
            </div>
            <div
              v-else-if="
                !isShowJson && form.type == typeEumn.heroUpgradeLeaderboardName
              "
            >
              <HeroUpgradeLeaderboard
                :parameter="form.parameter"
                @updated="upsertParameter"
              />
            </div>
            <div
              v-else-if="
                !isShowJson && form.type == typeEumn.anniversaryMission
              "
            >
              <AnniversaryMission
                :parameter="form.parameter"
                @updated="upsertParameter"
              />
            </div>
            <div v-else>
              <el-input
                placeholder="参数必须是JSON格式（可以不填）"
                type="textarea"
                rows="15"
                v-model="form.parameter"
              ></el-input>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import HeroUpgradeGift from "./child_config_param_template/HeroUpgradeGift";
import HeroUpgradeTask from "./child_config_param_template/HeroUpgradeTask";
import HeroUpgradeLeaderboard from "./child_config_param_template/HeroUpgradeLeaderboard";
import AnniversaryMission from "./child_config_param_template/AnniversaryMission";

// 本弹窗名称
const DialogName = "EditChildActivityConfigDialog";
export default {
  components: {
    HeroUpgradeGift,
    HeroUpgradeTask,
    HeroUpgradeLeaderboard,
    AnniversaryMission,
  },
  data() {
    return {
      isShowJson: false,
      visible: true,
      form: {},
      isCreated: false,
      width: "761px",
      types: ["英雄冲分-礼包", "英雄冲分-任务", "英雄冲分-排行奖励"],
      typeEumn: {
        heroUpgradeGiftName: "英雄冲分-礼包",
        heroUpgradeTaskName: "英雄冲分-任务",
        heroUpgradeLeaderboardName: "英雄冲分-排行奖励",
        anniversaryMission: "周年任务",
      },
      dataVerification: async () => {
        return;
      },
    };
  },

  computed: {
    hasUI() {
      switch (this.form.type) {
        case this.typeEumn.heroUpgradeGiftName:
        case this.typeEumn.heroUpgradeTaskName:
        case this.typeEumn.heroUpgradeLeaderboardName:
        case this.typeEumn.anniversaryMission:
          return true;
      }
      return false;
    },
  },
  async created() {
    let value = this.$dialogutil.getData(DialogName);

    if (value.entry != null) {
      this.form = value.entry;
    }

    this.isCreated = value.isCreated;

    await this.loadActivityTypes();

    this.typeValueChange(this.form.type);
  },

  methods: {
    toJsonSwitch(e) {
      if (e) {
        let tmpObj = JSON.parse(this.form.parameter);
        this.form.parameter = JSON.stringify(tmpObj, null, "    ");
      }
    },
    typeValueChange(e) {
      switch (e) {
        case this.typeEumn.heroUpgradeGiftName: {
          this.width = "1061px";
          break;
        }
        case this.typeEumn.heroUpgradeTaskName: {
          this.width = "1261px";
          break;
        }
        case this.typeEumn.heroUpgradeLeaderboardName: {
          this.width = "1278px";
          break;
        }
        case this.typeEumn.anniversaryMission: {
          this.width = "1478px";
          break;
        }
        default: {
          this.width = "761px";
        }
      }
    },
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      let v = await this.dataVerification();
      if (v) {
        this.$message.error(v.errMsg);
        return;
      }

      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增子活动配置？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addChildActivityConfig`,
            {
              config: this.form,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;

        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "新增成功",
          type: "success",
        });
        // 关闭当前对话框
        this.onClose();
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改子活动配置？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateChildActivityConfig`,
            {
              config: this.form,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;

        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });
        // 关闭当前对话框
        this.onClose();
      } catch (e) {}
    },

    /**
     * 加载活动类型
     */
    async loadActivityTypes() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryChildActivityTypes`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.types || [];

      this.types = listInResponse;
    },

    isShowJsonBtn(t) {
      for (let tt of this.types) {
        if (tt == t) {
          return true;
        }
      }

      return false;
    },

    async upsertParameter(param, dataVerification) {
      this.form.parameter = param;
      if (dataVerification) {
        this.dataVerification = dataVerification;
      }
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

